import { gql } from "apollo-boost";

const GET_ORDER_LINES = gql`
  query getOrderLines($input: GetOrderLines) {
    getOrderLines(input: $input) {
      data {
        orderLines {
          _id
          vendor
          status
          fulfillmentService
          fulfillmentStatus
          vendorId
          quantity
          markUpPrice
          price
          wholesalePrice
          orderId
          orderNumber
          accountingStatus
          commissionSeller
          commissionVendor
          createdAt
          shopifyOrderId
          shopifyLineItemId
          moneyFormat
          name
          totalDiscount
          paidVia
          trackingNumber
          vendorWholesalePrice
        }
      }
      status
      error
    }
  }
`;

const CHECK_ORDER_LINES = gql`
  query checkOrderLines($input: CheckOrderLines) {
    checkOrderLines(input: $input) {
      data {
        _id
        fulfillmentStatus
        vendorId
      }
      status
      error
    }
  }
`;

export { CHECK_ORDER_LINES, GET_ORDER_LINES };
